// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3U2t4","range":"MonthRangeSwitch_range__2Zayk","disabled":"MonthRangeSwitch_disabled__2qbMG"};